export default __webpack_public_path__ + "static/media/ai.f629f474.png";